export default function addSourcePageToForm(feildSelector) {
    const fields = document.querySelectorAll(`${feildSelector}`);
    if (!fields)
        return false;
    fields.forEach(field => {
        field.value = `${document.title} (${document.URL})`;
    });
}
;
